




































export interface ViewExportOption {
  headers: Array<{ label: string; property: string }>;
  data: Array<any>;
  fileName: string;
}

import { Vue, Component, Ref, Watch } from "vue-property-decorator";
import { Table } from "element-ui";
import { exportExcel } from "./xlsx";

@Component({
  name: "ExportDialog",
  components: {}
})
export default class ExportDialog extends Vue {
  private visible: boolean = false;

  private option: ViewExportOption = {headers: [], data: [], fileName: ""};

  private checkedList: Array<{ label: string; property: string }> = [];

  @Ref("table")
  private table!: Table;

  handleSelectionChange(checkedList: Array<any>) {
    this.checkedList = checkedList;
  }

  close() {
    this.visible = false;
  }

  submit() {
    if (this.checkedList.length === 0) return;

    const data: Array<Array<string>> = [];
    const header = this.checkedList.map((d) => d.label);

    this.option.data.forEach((d) => {
      const row: Array<string> = [];
      this.checkedList.forEach((x) => {
        row.push(d[x.property] || "");
      });
      data.push(row);
    });

    exportExcel({header, data, fileName: this.option.fileName});

    this.close();
  }

  show(option: ViewExportOption) {
    this.option = JSON.parse(JSON.stringify(option));
    this.visible = true;
    this.$nextTick(() => {
      this.table.clearSelection();
      this.table.toggleAllSelection();
    });
  }

  reset() {
    this.checkedList = [];
    this.option = {headers: [], data: [], fileName: ""};
    this.table.clearSelection();
  }

  @Watch("visible")
  onClose(newValue: boolean) {
    if (newValue === false) {
      this.reset();
    }
  }
}
